<template>
  <div class="box warehousedoc-form">
    <h2>Szczegóły</h2>
    <app-spoiler title="Dane Podstawowe">
      <div class="row row--2sm">
        <app-select type="number" name="numeration" placeholder="Numeracja" required v-model="selectedNumeration">
          <option v-for="numeration in numerations" :key="numeration.id" :value="numeration.id">{{ numeration.name }}</option>
          <option :value="-1" >Niestandardowa</option>
        </app-select>
        <app-input :disabled="selectedNumeration != -1" type="text" name="name" placeholder="Numer dokumentu" required v-model="data.name" autocomplete="no"></app-input>
      </div>
      <div class="row row--4">
        <app-input type="text" name="place" placeholder="Miejsce wystawienia" required v-model="data.place"></app-input>
        <app-select type="number" name="subtype" placeholder="Typ dokumentu" required v-model="data.subtype">
          <option :value="1">Przyjęcie zewnętrzne (PZ)</option>
          <option :value="2">Wydanie zewnętrzne (WZ)</option>
          <option :value="3">Przyjęcie wewnętrzne (PW)</option>
          <option :value="4">Rozchód wewnętrzny (RW)</option>
          <option :value="0">Inny</option>
        </app-select>
        <app-select type="number" name="warehouse" placeholder="Magazyn" v-model="data.details.warehouse_id">
          <option v-for="warehouse in warehouses" :key="warehouse.id" :value="warehouse.id">{{ warehouse.name }}</option>
        </app-select>
        <app-select type="number" name="theme" placeholder="Motyw" required v-model="data.details.theme">
          <option v-for="theme in themes" :key="theme.id" :value="theme.id">{{ theme.name }}</option>
        </app-select>
      </div>
      <app-input type="date" name="date_create" placeholder="Data wystawienia" required v-model="data.creation_date"></app-input>
      <app-input type="text" name="description" placeholder="Uwagi dla klienta" v-model="data.details.description"></app-input>
      <app-input type="text" name="tags" placeholder="Tagi (rozdzielone przecinkami)" v-model="data.tags"></app-input>
    </app-spoiler>

    <FromToForm :contractors="contractors" v-model="fromToForm" :company="company" ref="fromToForm" />

    <app-spoiler title="Pozycje" ref="items">
      <div class="item" v-for="(item, i) in data.details.items" :key="`item${i}`">
        <button class="item__del" type="button" v-if="data.details.items.length > 1" @click="delItem(i)"><i class="fas fa-times"></i></button>
        <div class="row">
          <app-input type="text" :name="`symbol${i}`" placeholder="Symbol" required v-model="data.details.items[i].symbol" />
          <app-input type="text" :name="`name${i}`" placeholder="Nazwa" required v-model="data.details.items[i].name" />
        </div>
        <div class="row row--2">
          <app-input :disabled="data.subtype == 2" type="number" :name="`value${i}`" step="0.000001" placeholder="Cena netto" required v-model="data.details.items[i].value" />
          <app-input type="number" :name="`qty${i}`" step="0.000001" placeholder="Ilość" required v-model="data.details.items[i].qty"></app-input>
        </div>
      </div>
      <div class="add-item">
        <button class="btn btn--small" @click="addItem" type="button"><i class="fas fa-plus"></i></button>
      </div>
    </app-spoiler>
  </div>
</template>

<script>
import Input from "@/components/Input.vue"
import FromToForm from "@/components/forms/FromToForm.vue"
import Select from "@/components/Select.vue"
import Spoiler from '@/components/Spoiler.vue'
import {api} from '@/api'

export default {
  name: "add-invoice",
  components: {
    AppInput: Input,
    AppSelect: Select,
    AppSpoiler: Spoiler,
    FromToForm
  },
  data() {
    return {
      company: {},
      themes: [],
      warehouses: [],
      contractors: [],
      numerations: [],
      selectedNumeration: -1,
      fromToForm: {
        from: {},
        to: {},
        direction: 1
      },
      originalName: '',
      originalNameID: '',
      data: {
        id: null,
        system: 0,
        subtype: 2,
        type: 2,
        name: '',
        tags: '',
        place: '',
        creation_date: new Date().toISOString().slice(0,10),
        details: {
          description: '',
          warehouse_id: 1,
          items: [
            {
              symbol: '',
              name: '',
              value: 0,
              qty: 1
            }
          ]
        },
      }
    }
  },
  methods: {
    addItem() {
      this.data.details.items.push({
        name: '',
        value: 0,
        qty: 0,
        tax: 23
      })

      this.$forceUpdate()
      this.$refs.items.setMaxHeight()
    },
    delItem(i) {
      if(this.data.details.items.length <= 1) return

      this.data.details.items.splice(i, 1)

      this.$forceUpdate()
      this.$refs.items.setMaxHeight()
    },
    setData(val) {
      this.data = val
      this.fromToForm = {
        from: val.from,
        to: val.to,
        direction: val.direction
      }
      this.originalName = this.data.name
      this.originalNameID = this.data.name_id

      this.$forceUpdate()
      this.$refs.items.setMaxHeight()
    },
    fillWithOrg(...args) {
      this.$refs.fromToForm.fillWithOrg(...args)
    }
  },
  props: {
    edit: Boolean
  },
  watch: {
    data: {
      handler() {
        this.$emit('input', {
          ...this.data,
          ...this.fromToForm
        })
      },
      deep: true
    },
    selectedNumeration() {
      if(this.selectedNumeration == -1) {
        this.data.name = ""
        this.data.name_id = undefined
      } else {
        this.data.name_id = this.selectedNumeration

        this.data.name = typeof this.data.id !== 'undefined' && this.data.name_id === this.originalNameID
          ? this.originalName
          : "Numer generowany automatycznie"
      }
    }
  },
  computed: {
    orgID() {
      return this.$store.state.user.activeOrganization
    }
  },
  async created() {
    try {
      const { data: organizationData} = await api.get(`/organizations/${this.orgID}`)

      this.company = organizationData.company
      this.themes = organizationData.themes
      this.warehouses = organizationData.warehouses
      this.numerations = organizationData.names
      this.data.details.theme = organizationData.default_theme

      const { data: contractorsData } = await api.get(`/organizations/${this.orgID}/contractors`)
      this.contractors = contractorsData

      if(!this.edit) {
        this.selectedNumeration = this.numerations[0]?.id || -1 // TODO: ?? instead of ||
        this.data.place = this.company.city
      }

    } catch(e) {
      console.error(e)
    }
  }
};
</script>

<style lang="scss" scoped>

.add-item {
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

h2 {
  text-align: center;
  font-weight: 300;
  margin-top: 0;
  font-size: 1.1em;
}

.input {
  font-size: 0.9em;
}

.row {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 0 16px;

  @media screen and (min-width: #{$media-600}) {
    grid-template-columns: 1fr 1fr;
  }

  &--2sm {
    grid-template-columns: 0.3fr 1fr;
  }

  &--3asym {
    grid-template-columns: 1fr 1fr;

    >*:first-child {
      grid-column: 1/3;
    }

    @media screen and (min-width: #{$media-600}) {
      grid-template-columns: 1fr 0.5fr 0.5fr;

      >*:first-child {
        grid-column: auto;
      }
    }
  }

  &--3 {
    grid-template-columns: 1fr 1fr;

    @media screen and (min-width: #{$media-600}) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  &--4 {
    grid-template-columns: 1fr 1fr;

    @media screen and (min-width: #{$media-600}) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

  }
}

.warehousedoc-form {
  box-sizing: border-box;
  padding: 16px;
  width: 100%;
}

.item {
  padding: 0 0 16px;
  border-bottom: 1px dashed #bbb;
  position: relative;

  &__del {
    all: unset;
    position: absolute;
    top: 0; right: 0;
    color: firebrick;
    cursor: pointer;
    transition: 0.3s;
    z-index: 10;

    &:hover {
      transform: rotate(90deg);
    }

  }
}
</style>
